import React, { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import { i18n } from '../../translate/i18n';
import { isEmpty, uniqueId } from 'lodash';
import filesize from "filesize";
import API from '../../axios/api';
import * as actions from "../../store/actions";
import axios from "axios";
import EditIcon from '@mui/icons-material/Edit';
import DeleteIcon from '@mui/icons-material/Delete';
import {
  Typography, IconButton, TextField, FormControl, FormControlLabel, FormLabel, Radio, RadioGroup
} from '@mui/material';
import {
  FormStyled, DoneIconStyled, DivSubmitButtons, DivFormTitle
} from '../../containers/Admin/Forms/styles';
import CloseIcon from '@mui/icons-material/Close';
import Upload from '../../UI/Upload';
import FileList from '../../UI/FileList';
import confirm from '../../UI/Confirm/confirm';
import { map as asyncMap } from 'p-iteration';

const ModalSupportFiles = (props) => {
  const dispatch = useDispatch();

  const [isNewData, setIsNewData] = useState(true);
  const [editMode, setEditMode] = useState(false);
  const [uploadSubmitError, setUploadSubmitError] = useState(false)
  const [uploadEmptyFileError, setUuploadEmptyFileError] = useState(false)

  const [description, setDescription] = useState('');
  const [visibility, setVisibility] = useState('internal');
  const [uploadedFiles, setUploadedFiles] = useState([]);
  const [filesToDelete, setFilesToDelete] = useState([]);

  const postSupportFile = (body) => dispatch(actions.postSupportFiles(body))
  const updateSupportFile = (documentId, body) => dispatch(actions.updateSupportFiles(documentId, body))
  const deleteSupportFile = (documentId) => dispatch(actions.deleteSupportFiles(documentId))

  useEffect(() => {
    if (props.type === 'edit') {
      setVisibility(props.modalContent.visibility)
      setDescription(props.modalContent.description)
      setIsNewData(false)
      setUploadedFiles(props.modalContent.file)
      setFilesToDelete([])
    } else {
      setVisibility('internal')
      setDescription('')
      setUploadedFiles([])
      setFilesToDelete([])
    }
  }, [])

  const handleSubmit = async e => {
    e.preventDefault();
    let hasError = false;

    const notUploaded = uploadedFiles.filter(fl => fl.isNotUploaded)
    if (notUploaded.length > 0) {
      setUploadSubmitError(true)
      hasError = true;
    }

    const filesIds = []
    uploadedFiles.map(fl => {
      if (fl.id)
        return filesIds.push(fl.id)
      else if (fl._id)
        return filesIds.push(fl._id)
    })

    if (uploadedFiles.length === 0) {
      setUuploadEmptyFileError(true);
      hasError = true;
    }

    if (hasError) return;

    const body = {
      files: filesIds,
      description,
      visibility
    };

    if (isNewData) {
      postSupportFile(body).then(async result => {
        if (result === 'success') {
          await asyncMap(filesToDelete, async file => await API.delete(`files/${file}`));
          props.closeModal(false, '')
        }
      })
    } else {
      updateSupportFile(props.modalContent._id, body).then(async result => {
        if (result === 'success') {
          await asyncMap(filesToDelete, async file => await API.delete(`files/${file}`));
          props.closeModal(false, '')
        }
      })
    }
  }

  const handleUpload = files => {
    const uploadingFiles = files.map(file => ({
      file,
      id: uniqueId(),
      name: file.name,
      readableSize: filesize(file.size),
      preview: URL.createObjectURL(file),
      fileType: file.type,
      progress: 0,
      isNotUploaded: true,
      error: false,
      url: null
    }));
    setUploadedFiles(prevUf => prevUf.concat(uploadingFiles))
    uploadingFiles.forEach(processUpload);
  };

  const updateFile = (id, data) => {
    setUploadedFiles(prevUf => prevUf.map(uf => id === uf.id ? { ...uf, ...data } : uf))
  };

  const processUpload = async uploadedFile => {
    const payloadToSign = {
      fileType: uploadedFile.fileType,
      name: uploadedFile.name
    };

    API.post("files/signurl", { file: payloadToSign }).then(signUrlRes => {
      axios.put(signUrlRes.data.url, uploadedFile.file, {
        onUploadProgress: e => {
          const progress = parseInt(Math.round((e.loaded * 100) / e.total));
          updateFile(uploadedFile.id, {
            progress
          });
        },
        headers: { 'Content-Type': signUrlRes.data.contentType }
      }).then((res) => {
        const body = {
          name: uploadedFile.file.name,
          size: uploadedFile.file.size,
          key: `files/${signUrlRes.data.fileName}`,
          mimetype: signUrlRes.data.contentType
        }

        API.post("files", body)
          .then(response => {
            setUploadSubmitError(false)
            updateFile(uploadedFile.id, {
              isNotUploaded: false,
              id: response.data._id,
              url: response.data.url,
              error: false,
              loading: false,
            });
          })
          .catch(() => {
            updateFile(uploadedFile.id, {
              error: true,
              loading: false,
            });
          });
      })
    })
  }

  const handleDeleteDocumentFile = async id => {
    setFilesToDelete(prev => [...prev, id]);
    setUploadedFiles(prev => prev.filter(file => file.id !== id))
  }

  const handleDeleteDocument = (documentId) => {
    confirm(i18n.t('handleDeleteDocumentModalSupport.confirm'),
      {
        title: i18n.t('handleDeleteDocumentModalSupport.title'),
        titleColor: 'red',
        disableBackdrop: true
      }).then(
        () => { },
        async () => {
          deleteSupportFile(documentId).then(async result => {
            if (result === 'success') {
              await asyncMap(uploadedFiles.map(file => file.id ? file.id : file._id), async file => await API.delete(`files/${file}`));
              props.closeModal(false, '')
            }
          })
        },
      )
  }


  const styles = {
    opacityContainer: {
      position: 'relative'
    },
    fileError: {
      color: '#f44336'
    },
		submittedContainer: {
			display: 'flex',
			color: 'grey',
			fontSize: '0.8rem',
			marginTop: '1rem'
		}
  }

  return (
    <FormStyled onSubmit={handleSubmit} style={styles.opacityContainer}>
      <DivFormTitle>
        <Typography variant='h6'>{isNewData ? i18n.t('modalSupportTypo.isNewDataTrue') : i18n.t('modalSupportTypo.isNewDataFalse') }</Typography>
        {!isNewData &&
          <DivSubmitButtons>
            {editMode ?
              <>
                <IconButton onClick={() => props.closeModal(false, 'close')} size="large"><CloseIcon color='error' /></IconButton>
                <IconButton type="submit" size="large"><DoneIconStyled /></IconButton>
              </> :
              <>
                <IconButton onClick={() => setEditMode(true)} size="large"><EditIcon /></IconButton>
                <IconButton onClick={() => handleDeleteDocument(props.modalContent._id)} size="large"><DeleteIcon /></IconButton>
              </>
            }
          </DivSubmitButtons>
        }
      </DivFormTitle>
      <FormControl variant="standard" fullWidth margin='normal' style={{marginBottom: 20}}>
        <TextField
          variant="standard"
          label={i18n.t('modalSupportTextField.label')}
          multiline
          minRows={3}
          disabled={!isNewData && !editMode}
          name='description'
          onChange={event => setDescription(event.target.value) }
          value={description} />
      </FormControl>
      <FormControl variant="standard" margin='normal' disabled={!isNewData && !editMode}>
        <FormLabel>{i18n.t('formLabelModalSupportFiles.label')}</FormLabel>
        <RadioGroup aria-label="gender" name="gender1" value={visibility} onChange={event => setVisibility(event.target.value)}>
          <FormControlLabel value="all" control={<Radio />} label={i18n.t('formControlLabelModalSupportFiles.all')} />
          <FormControlLabel value="internal" control={<Radio />} label={i18n.t('formControlLabelModalSupportFiles.internal')} />
          <FormControlLabel value="external" control={<Radio />} label={i18n.t('formControlLabelModalSupportFiles.external')} />
        </RadioGroup>
      </FormControl>

      <Upload onUpload={handleUpload} disabled={!isNewData && !editMode} />
      {!isEmpty(uploadedFiles) && uploadedFiles.map(file => (
        <FileList files={[file]} onDelete={handleDeleteDocumentFile} disabled={!editMode && !isNewData} />
      ))}
      {uploadSubmitError && <div style={styles.fileError}>{i18n.t('uploadSubmitErrorModalSupport.label')}</div>}
      {uploadEmptyFileError && <div style={styles.fileError}>{i18n.t('uploadEmptyFileErrorModalSupport.label')}</div>}
      {isNewData &&
        <DivSubmitButtons>
          <IconButton onClick={() => props.closeModal(false, 'close')} size="large"><CloseIcon fontSize='large' color='error' /></IconButton>
          <IconButton type="submit" size="large"><DoneIconStyled fontSize='large' /></IconButton>
        </DivSubmitButtons>
      }

    </FormStyled>
  );
}

export default ModalSupportFiles;
